export default __webpack_public_path__ + "static/media/maheshwar.574bf5cb.jpg";